var m = require('mithril');
var go = require('gojs');
var edit = require('../../../../layout/components/edit');
var editCustomEquipmentModal = require('../../../editCustomEquipmentModal');
var gridEquipmentNode = require('./helpers/gridEquipmentNode');
var $ = go.GraphObject.make;  // for more concise visual tree definitions
var portCoverBrush = $(go.Brush, "Linear", { 0: "#2a2a2a", 1: "#f0f0f0", start: go.Spot.Bottom, end: go.Spot.Top });
var manifoldGridDefaults = { cols: 3, rows: 3 };

function createGridPortOptions(defaults, isCenterPort) {
  return {
    defaults: defaults || manifoldGridDefaults,
    isCenterPort: isCenterPort === true,
    isEditing: function() {
      return edit.vm.editing();
    },
    portCoverBrush: portCoverBrush,
    allowMultipleLinks: isCenterPort === true
  };
}

function createManifoldNodeTemplate(map, useGeoPositioning, submitCallback) {
  var gridDefaults = manifoldGridDefaults;
  return $(go.Node, "Spot",
  {
    locationSpot: go.Spot.TopLeft,
    resizeObjectName: "BODY",
    selectionObjectName: "BODY",
    selectionAdornmentTemplate: gridEquipmentNode.createSelectionAdornmentTemplate(),
    resizeCellSize: gridEquipmentNode.getResizeCellSize(),
    contextMenu: edit.vm.editing() ? $("ContextMenu",
      $("ContextMenuButton",
        $(go.TextBlock, "Edit Equipment"),
        { 
          click: (e, obj) => {
            editCustomEquipmentModal.editDialogue({...obj.part.data}, { submitCallback: submitCallback, delete: true })
            m.redraw();
          }
        }
      ),
      $("ContextMenuButton",
        $(go.TextBlock, "Edit Permissions"),
        { 
          click: (e, obj) => {
            m.route.set(`/equipment/${obj.part.data['class']}/${obj.part.data['key'].toString().slice(1)}/permissions`)
          }
        }
      )
    ) : null,
  },
  new go.Binding("cursor", "", data => {
    return edit.vm.editing() ? "pointer" : "default";
  }),
  new go.Binding("deletable", "", data => {
    return edit.vm.editing();
  }),
  new go.Binding("selectable", "", data => {
    return edit.vm.editing();
  }),
  new go.Binding("movable", "", data => {
    return edit.vm.editing();
  }),
  new go.Binding("resizable", "", data => {
    return edit.vm.editing();
  }),
  useGeoPositioning ? 
    new go.Binding("location", "latlong", data => {
      const pos = map.project(data, map.getZoom());
      return new go.Point(pos.x, pos.y);
    }).makeTwoWay((pt, data) => {
      if (updatingGoJs) {
        return data.latlong; // no-op
      } else {
        const ll = map.unproject(L.point(pt.x, pt.y), map.getZoom());
        return [ll.lat, ll.lng];
      }
    })
  : 
    new go.Binding("location", "latlong", data => {
      return new go.Point(data[0], data[1]);
    }),
    $(go.Panel, "Auto",
      {
        name: "BODY",
        alignment: go.Spot.Center,
        alignmentFocus: go.Spot.Center,
        stretch: go.GraphObject.Fill
      },
      gridEquipmentNode.createBodySizeBinding(gridDefaults),
      $(go.Shape, "Rectangle",
        {
          fill: edit.vm.editing() ? $(go.Brush, "Linear", { 0.0: "#2a2a2a", 1.0: "white", start: go.Spot.Bottom, end: go.Spot.Top }) : 'transparent',
          visible: edit.vm.editing() ? true : false,
          stroke: edit.vm.editing() ? "black" : "transparent",
          strokeWidth: 2,
          stretch: go.GraphObject.Fill
        }),
    ),
    gridEquipmentNode.createSpotPortPanel("centerArray", "center", createGridPortOptions(gridDefaults, true))
  )
}





module.exports = createManifoldNodeTemplate;
